/**
 * Google Analytics 4 (G-D1WD7SHZCE).
 *
 * The tag itself is installed in public/index.html with `send_page_view: false`, because a
 * single-page app must send its own page_view on every client-side navigation — otherwise GA4
 * only ever records the landing URL. Everything else funnels through `gaEvent`, which is also
 * wired into the internal `track()` helper so every product event lands in both systems.
 */
export const GA_ID = "G-D1WD7SHZCE";

const gtag = (...args) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag(...args);
};

const section = (path) => {
  if (path.startsWith("/studio")) return "studio";
  if (path.startsWith("/admin")) return "admin";
  if (path.includes("/blog")) return "blog";
  if (path.includes("/pricing")) return "pricing";
  if (path.includes("/templates")) return "templates";
  if (/^\/(fr|en)$/.test(path)) return "home";
  return "content";
};

export const gaPageView = ({ path, title, locale }) =>
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title,
    content_group: section(path),
    locale,
  });

export const gaEvent = (name, params = {}) =>
  gtag("event", String(name).replace(/[^a-zA-Z0-9_]/g, "_").slice(0, 40), params);

export const gaIdentify = (user) => {
  if (!user) {
    gtag("set", { user_id: undefined });
    return;
  }
  gtag("set", { user_id: user.user_id || user.id });
  gtag("set", "user_properties", {
    plan: user.plan || "anonymous",
    role: user.role || "user",
    locale: user.locale || "en",
  });
};

export const gaConsent = (granted) =>
  gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: "denied",
  });
